import { Router } from '@angular/router';
import { fdSelectModelList } from './../../models/fdSelect.model';
import { Component, OnInit } from '@angular/core';
import { UrlService } from '../../shared/services/url.service';
import { UrlControl } from '../../shared/models/generic.model';
import { AlertService } from '../../shared/services/alert.service';
import { GlobalService } from 'src/app/shared/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { fdSelectModel } from 'src/app/models/fdSelect.model';
import { Route } from '@angular/compiler/src/core';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
  selector: 'app-configuracion-discapacidad',
  templateUrl: './configuracion-discapacidad.component.html',
  styleUrls: ['./configuracion-discapacidad.component.scss']
})
export class ConfiguracionDiscapacidadComponent implements OnInit {

  public filtroGenerico: string;
  public listadoVisitantes: any[] = [];
  public listadoDependencias: any[] = [];
  public elementListVisitante: any;


  public filtroOrdenamiento: string;
  public filtroTipoDiscapacidad;
  public filtroNombre: string;

  public listaDiscapacidades = [];
  public listaTipoDiscapacidades = [];
  public listaDiscapacidadesSelect: fdSelectModelList;
  public listaGrupoDiscapacidades = [];

  constructor(
      private urlService: UrlService, private spiner: NgxSpinnerService
    , private alertService: AlertService
    , private global: GlobalService, private router: Router, ) {
    this.listaDiscapacidades = [];
    this.listaTipoDiscapacidades = [];
    this.filtroOrdenamiento = 'ASC';
    this.filtroNombre = null;
    this.filtroTipoDiscapacidad = [];


  }

  ngOnInit() {

    this.obtenerTipoDiscapacidad();
  }

  // fromero
  // 03/05/2019
  // Método para consultar dominio, filtrado por tipoDiscapacidad

  public obtenerTipoDiscapacidad() {
    this.spiner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'TipoDiscapacidad']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.getGenerico(url).subscribe(
      data => {
        if (data.length <= 1) {
          this.cathException('No hay discapacidades Disponibles');
        } else {
          data.forEach(element => {
            const tipoDiscapacidad = new Object({
              nombreTipoDiscapacidad: element.detalleDominioPK.nombreDetalleDominio,
              idTipoDiscapacidad: element.valor

            });

            const el = {
              nombreElelemento: element.detalleDominioPK.nombreDetalleDominio,
              checked: false,
              id: element.valor
            }

            this.listaDiscapacidades.push(tipoDiscapacidad);
            this.listaTipoDiscapacidades.push(el);

          });
          this.getGruposDiscapacidades();
        }

      }, err => {
        this.cathException('No es posible Obtener tipo Discapacidades', err);
      }
    );
  }


  // fromero
  // Meotodo para retrasar la bùsqueda
  buscarDiscapacidadesfiltro(filtro?) {

    setTimeout(() => {
      // this.getGruposDiscapacidades()
    }, 3000);
  }
  // fromero
  // 03/05/2019
  // Mètodo par hacer pèticiòn al backend de Grupos de Discapacidades
  getGruposDiscapacidades() {

    const serviceProvider = 'ObtenerGrupoDiscapacidad';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);

    const objetoPeticion = {
      tipoDiscapacidad: this.filtroTipoDiscapacidad
      , order: this.filtroOrdenamiento
      , nombreDiscapacidad: this.filtroNombre
    }

    this.global.postGenerico(url, objetoPeticion).subscribe(
      data => {
        if (data.length < 1) {
          this.cathException('No se encontró discapacidad');
          this.listaGrupoDiscapacidades = [];
        } else {
          this.listaGrupoDiscapacidades = data;

          const tempArray = [];
          this.listaGrupoDiscapacidades.forEach(element => {
            if (element.idGrupoDiscapacidad !== 0) {
              tempArray.push(element);
            }
          });

          this.listaGrupoDiscapacidades = tempArray;

        }
        this.spiner.hide();
      }, err => {
        this.cathException('No se encontró discapacidad ', err);
      }
    );
  }


  public editarGrupo(event) {
    if (event.objeto.idGrupoDiscapacidad || event.objeto.idGrupoDiscapacidad === 0) {
      this.navegarDetalle(event.objeto);
    } else {
      this.cathException('No es posible cargar el grupo');
    }

  }

  public asignarGrupoDiscapacidad() {
    const serviceProvider = 'ObtenerFuncionario';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);

    this.global.postGenerico(url).subscribe(
      data => {
        this.listadoVisitantes = data;
      }, err => {
        this.cathException(err);
      }
    );

  }

  setFiltroDiscapacidades(event) {
    this.filtroTipoDiscapacidad = [];
    event.elementosSeleccionados.forEach(element => {
      if (element.checked) {
        this.filtroTipoDiscapacidad.push(element.id);
      }
    });
  }
  cathException(error, err?) {
    this.alertService.generateAlertError(error, ' ');
    this.spiner.hide();
  }


  navegarDetalle(grupo) {
    this.global.zonaCompartida[VariablesZonaCompartida.DETALLE_GRUPO_DISCAPACIDAD] = {
      idGrupo: grupo.idGrupoDiscapacidad
      , nombreGrupo: grupo.nombre
    };
    this.router.navigate(['main/configuracion-discapacidad/detalle-grupo-discapacidad']);
  }

}

